import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ISessionEndedStore} from './session-ended.stores';
import {IAppRootStore} from '../../app.root.store';
import {SessionEnded} from '../../components/session-ended/session-ended';

interface SessionEndedViewProps {
    sessionEndedStore: ISessionEndedStore;
    rootStore: IAppRootStore;
}

@observer
export class SessionEndedViewComponent extends TechseeBaseComponent<SessionEndedViewProps> {
    renderInternal(): JSX.Element {
        const {sessionEndedStore} = this.props;
        return <SessionEnded controller={sessionEndedStore.sessionEndedController} />;
    }
}

export const SessionEndedView = inject('rootStore', 'sessionEndedStore')(SessionEndedViewComponent) as IReactComponent;
